import clsx from "clsx";

export const CardSide: React.FC<{
  isBackSide?: boolean;
  children: React.ReactNode;
}> = ({ children, isBackSide }) => {
  return (
    <div
      className={clsx(
        "absolute inset-0 flex items-center justify-center p-4 text-center backface-hidden",
        isBackSide && "rotate-y-180",
      )}
    >
      {children}
    </div>
  );
};
